$(function() {
	// -------------------------------------------
	// PC/SMP共通処理
	// -------------------------------------------
	if (!window.Nifty || !window.Nifty.Utils) {
		return;
	}
	window.Nifty.WallPaint = window.Nifty.WallPaint || {};
	window.Nifty.Data = window.Nifty.Data || {};

	// 共通: SMP/PC共通関数
	Nifty.WallPaint.Function = {
		_$loadingElement: $('#loading')
		,setShowLoading: function(shouldShow) {
			if (shouldShow) {
				this._$loadingElement.addClass('is-active');
			} else {
				this._$loadingElement.removeClass('is-active');
			}
		}
		// 共通: お気に入り件数表示
		,showBukkenFavoriteCount: function() {
			if (Nifty.Common.Header) {
				Nifty.Common.Header.updateHeaderCount();
			}
		}

		// フォーム内容の同期
		,setTextmatchSync: function() {
			$(document).on('change', '[data-textmatch-sync]', function() {
				$('[data-textmatch-sync="' + $(this).attr('data-textmatch-sync') + '"]').val($(this).val());
			});
		}
		,setSelectmatchSync: function() {
			$(document).on('change', '[data-selectmatch-sync]', function() {
				$('[data-selectmatch-sync="' + $(this).attr('data-selectmatch-sync') + '"]').val($(this).val());
			});
		}

		// カンタン検索: 未入力時にサジェストで表示するメッセージ生成
		,makeEasySearchSuggestTextIfEmpty: function(placeholder) {
			// 「を入力してください」がダブって表示されないように生成
			return placeholder.replace(/を入力.*/, '') + 'を入力してください';
		}

		// トグルリスト開閉
		,setEasyToggle: function() {
			$(document).on('click', '[data-easy-toggle-control]', function() {
				const parentElements = $(this).closest("[data-easy-toggle]");
				const contentElements = [
					...parentElements[0].querySelectorAll("[data-easy-toggle-content]")
				];
				const filterdElements = contentElements.filter(
					(contentElement) => contentElement.closest("[data-easy-toggle]") === parentElements[0]
				);
				filterdElements.map((filterd) => filterd.classList.toggle("is-active"));
			});
		}
	};

	// History API関連
	Nifty.WallPaint.History = {
		state: {
			RESULT_AJAX_PREV: 'resultAjaxPrev'
			,RESULT_AJAX_NEXT: 'resultAjaxNext'
		}
		// ブラウザバック時の処理
		,setPopstate: function() {
			const self = this;
			if (!self._isPopstateSet) {
				self._isPopstateSet = true;
				$(window).on('popstate', function(e) {
					const state = e.originalEvent.state;
					if (!state) {
						return;
					}
					if (state == self.state.RESULT_AJAX_PREV || state == self.state.RESULT_AJAX_NEXT) {
						location.href = (location.pathname + location.search);
					}
				});
			}
		}
	};

	// JsRender関連
	Nifty.WallPaint.JsRender = {
		// private
		_searchForm: null
		,_searchParamMap: null
		,_prefDataItem: null
		,_addCountToItems: function(items, facetData) {
			for (let id in items) {
				items[id].count = (facetData && facetData[id]) ? facetData[id] : 0;
			}
		}
		,_createPrefDataItem: function() {
			if (this._prefDataItem || !this._searchForm) {
				return;
			}
			const prefId = this._searchForm.getPrefId();

			const dataUtil = Nifty.Utils.Data;
			const areasData = dataUtil.getAreasData();
			const facetData = dataUtil.getFacetData();
			const confData = areasData.confData;
			const prefDatas = areasData.prefData;
			const stationDatas = areasData.stationData;
			const facetError = {
				city: !facetData.city
				,line: !facetData.line
				,station: !facetData.station
			};

			const prefItems = dataUtil.createDataItems(prefDatas, confData.pref)
			const prefItem = prefItems[prefId];
			// データ変換(駅)
			const stationDataItems = dataUtil.createDataItems(stationDatas, confData.station);
			this._addCountToItems(stationDataItems, facetData.station);
			// データ変換(路線)
			const lineDataItems = {};
			for (let tmpPrefId in prefItems) {
				const tmpPrefItem = prefItems[tmpPrefId];
				const lineDataItem = dataUtil.createDataItems(tmpPrefItem.lineData, confData.line);
				dataUtil.convertIdsToItems(lineDataItem, stationDataItems, 'stationIds', 'stations');
				this._addCountToItems(lineDataItem, facetData.line);
				for (let tmpLineId in lineDataItem) {
					const tmpLineItem = lineDataItem[tmpLineId];
					tmpLineItem.isEnabled = (facetError.line || tmpLineItem.count > 0 || this._searchForm.hasLineParamValue(tmpPrefItem.alpha, tmpLineItem.alpha));
				}
				lineDataItems[tmpPrefId] = lineDataItem;
			}
			// データ変換(対象都道府県)
			const prefDataItems = {
				mCity: dataUtil.createDataItems(prefItem.mCityData, confData.mCity)
				,city: dataUtil.createDataItems(prefItem.cityData, confData.city)
				,lineType: dataUtil.createDataItems(prefItem.lineTypeData, confData.lineType)
				,line: lineDataItems[prefId]
			};
			this._addCountToItems(prefDataItems.city, facetData.city);
			this._addCountToItems(prefDataItems.mCity, facetData.city);
			// 他県の路線/駅データ追加
			for (let lineId in prefDataItems.line) {
				const lineItem = prefDataItems.line[lineId];
				lineItem.otherPrefs = [];
				for (let tmpPrefId in prefItems) {
					const otherPrefLineItem = lineDataItems[tmpPrefId][lineId];
					if (tmpPrefId != prefId && otherPrefLineItem) {
						const tmpOtherPrefItem = prefItems[tmpPrefId];
						lineItem.otherPrefs.push({
							id: tmpOtherPrefItem.id
							,alpha: tmpOtherPrefItem.alpha
							,line: otherPrefLineItem
						});
					}
				}
			}
			// 市区町村/駅の有効/無効設定
			for (let tmpCityId in prefDataItems.city) {
				const cityDataItem = prefDataItems.city[tmpCityId];
				cityDataItem.isEnabled = (facetError.city || cityDataItem.count > 0 || this._searchForm.hasCityParamValue(prefItem.alpha, cityDataItem.alpha));
			}
			for (let tmpMCityId in prefDataItems.mCity) {
				const mCityDataItem = prefDataItems.mCity[tmpMCityId];
				mCityDataItem.isEnabled = (facetError.city || mCityDataItem.count > 0 || this._searchForm.hasCityParamValue(prefItem.alpha, mCityDataItem.alpha));
			}
			for (let tmpStationId in stationDataItems) {
				const stationDataItem = stationDataItems[tmpStationId];
				stationDataItem.isEnabled = (facetError.station || stationDataItem.count > 0 || this._searchForm.hasStationParamValue(prefItem.alpha, stationDataItem.alpha));
			}

			// 都道府県データ生成
			dataUtil.convertIdsToItems(prefDataItems.lineType, prefDataItems.line, 'lineIds', 'lines');
			dataUtil.convertIdsToItems(prefDataItems.mCity, prefDataItems.city, 'cityIds', 'cities');
			dataUtil.convertIdsToItem(prefItem, prefDataItems.mCity, 'mCityIds', 'mCities');
			dataUtil.convertIdsToItem(prefItem, prefDataItems.lineType, 'lineTypeIds', 'lineTypes');
			this._prefDataItem = {
				id: prefId
				,name: prefItem.name
				,alpha: prefItem.alpha
				,mCities: prefItem.mCities
				,lineTypes: prefItem.lineTypes
				,facetError: facetError
			};
		}

		// public
		,render: function($template, data) {
			if (!this._isConverterSet) {
				this._isConverterSet = true;
				this.setConverters();
			}
			return $template.render(data);
		}
		,renderAreaConditions: function($template, isFirstRender, isLineCondition) {
			this._createPrefDataItem();
			// 初回生成の場合、パラメータを引き継ぐ
			this._searchParamMap = (isFirstRender) ? this._searchForm.getAreasParamMap() : {};

			if (isLineCondition) {
				const lineIds = this._searchForm.getCheckedLineIds();
				if (lineIds && lineIds.length > 0) {
					for (let ltIdx = 0, ltMax = this._prefDataItem.lineTypes.length; ltIdx < ltMax; ltIdx++) {
						const lineTypeData = this._prefDataItem.lineTypes[ltIdx];
						for (let lnIdx = 0, lnMax = lineTypeData.lines.length; lnIdx < lnMax; lnIdx++) {
							const lineData = lineTypeData.lines[lnIdx];
							const lineValue = this._searchForm.makeLineValue(this._prefDataItem.alpha, lineData.alpha);
							lineData.checked = (lineIds.indexOf(lineValue) >= 0);
						}
					}
				}
			}
			return this.render($template, this._prefDataItem);
		}
		,setSearchForm: function(searchForm) {
			this._searchForm = searchForm;
		}
		// JsRender用コンバータ追加
		,setConverters: function() {
			const serf = this;

			const functions = {
				getCheckedAttr: function(name, value) {
					return (serf._searchParamMap[name] && serf._searchParamMap[name].indexOf(value) >= 0) ? 'checked="checked"' : '';
				}
				,getCityValue: function(prefDataItem, cityDataItem) {
					return serf._searchForm.makeCityValue(prefDataItem.alpha, cityDataItem.alpha);
				}
				,getLineValue: function(prefDataItem, lineDataItem) {
					return serf._searchForm.makeLineValue(prefDataItem.alpha, lineDataItem.alpha);
				}
				,getStationValue: function(prefDataItem, stationDataItem) {
					return serf._searchForm.makeStationValue(prefDataItem.alpha, stationDataItem.alpha);
				}
			};
			$.views.converters({
				// テキスト生成
				formatNumber: function(num) {
					return num.toLocaleString();
				}
				// URL生成
				,getImgUrl: function(url, domain, noimage) {
					if (!url) {
						return noimage;
					}
					if (!url.startsWith('http')) {
						return domain + url;
					}
					return url;
				}
				,getCityUrl: function(prefDataItem, cityDataItem) {
					return serf._searchForm.makeCityUrl(prefDataItem.alpha, cityDataItem.alpha);
				}
				,getLineUrl: function(prefDataItem, lineDataItem) {
					return serf._searchForm.makeLineUrl(prefDataItem.alpha, lineDataItem.alpha);
				}
				,getStationUrl: function(prefDataItem, stationDataItem) {
					return serf._searchForm.makeStationUrl(prefDataItem.alpha, stationDataItem.alpha);
				}
				// パラメータ値生成
				,getCityValue: functions.getCityValue
				,getLineValue: functions.getLineValue
				,getStationValue: functions.getStationValue
				// checked属性生成
				,getCityCheckedAttr: function(name, prefDataItem, cityDataItem) {
					return functions.getCheckedAttr(name, functions.getCityValue(prefDataItem, cityDataItem));
				}
				,getLineCheckedAttr: function(name, prefDataItem, lineDataItem) {
					return functions.getCheckedAttr(name, functions.getLineValue(prefDataItem, lineDataItem));
				}
				,getStationCheckedAttr: function(name, prefDataItem, stationDataItem) {
					return functions.getCheckedAttr(name, functions.getStationValue(prefDataItem, stationDataItem));
				}
			});
		}
	};

	// 検索フォーム関連
	Nifty.WallPaint.SearchForm = {
		// private
		_$form: null
		,_conf: null
		,_easySearchConf: null

		,_formatParamValue: function(value) {
			// 市区町村/駅パラメータを見やすくするためデコード
			return /^([a-z_]+)%3A([a-z_]+)(%3A([a-z_]+)|)$/i.test(value) ? value.replace(/%3A/g, ':') : value;
		}
		,_makeDistinctParamMap: function(query) {
			// ※query指定有りの場合はqueryを基に、query指定無しの場合はフォームを基に生成
			// ※空文字列は指定有りと見なす(条件選択ポップアップの件数取得時など、条件によっては渡されるqueryが空文字列のケースが有る為)
			query = (query !== undefined && query !== null) ? query : this._$form.serialize();
			const params = Nifty.Utils.Array.unique(query.split('&'));
			const distinctParamMap = {};
			for (let idx = 0, max = params.length; idx < max; idx++) {
				const pair = params[idx].split('=');
				if (pair.length == 2 && pair[1]) {
					if (!distinctParamMap[pair[0]]) {
						distinctParamMap[pair[0]] = [];
					}
					distinctParamMap[pair[0]].push(this._formatParamValue(pair[1]));
				}
			}
			return distinctParamMap;
		}
		,_makeResultQuery: function(query) {
			// クエリ生成: 重複、空値を除外、ソートし、同名複数パラメータをカンマ区切りで1つにまとめる
			let distinctParamString = '';
			const distinctParamMap = this._makeDistinctParamMap(query);
			const distinctParamKeys = Object.keys(distinctParamMap)
			for (let idx = 0, max = distinctParamKeys.length; idx < max; idx++) {
				distinctParamString += (distinctParamString ? '&' : '') + distinctParamKeys[idx] + '=' + distinctParamMap[distinctParamKeys[idx]].sort().join(',');
			}
			return distinctParamString;
		}
		,_makeResultUrl: function(excludeParams) {
			const self = this;
			const conf = self._conf;
			const $form = self._$form;
			let url = '';
			let query = '';
			if ($form && conf) {
				// 1件目のエリア(市区町村/駅)パラメータの正規化URLをform送信先URLとする
				const urls = [ '', '' ];    // 0: 現ページと同都道府県の市区町村/駅URL, 1: 現ページと異なる都道府県の市区町村/駅URL
				const queries = [ [], [] ]; // 同上
				const allQueries = [];
				const params = Nifty.Utils.Array.unique($form.serialize().split('&'));
				const lineParamValues = [];
				for (let idx = 0, max = params.length; idx < max; idx++) {
					const pair = params[idx].split('=');
					if (pair.length != 2 || !pair[1] || excludeParams && excludeParams.indexOf(pair[0]) >= 0) {
						continue;
					}
					if (!urls[0]) {
						// 優先度の高いエリアURLが未設定の場合のみ実行
						const isCity = (pair[0] == conf.param.city);
						const isStation = (pair[0] == conf.param.station);

						const areas = self._formatParamValue(pair[1]).split(':');
						const isSamePref = (!conf.form.prefAlpha || areas[0] == conf.form.prefAlpha);

						// form送信先URLとするエリアパラメータの場合、form送信先に設定しクエリには追加しない
						if (!urls[0] && (isCity || isStation)) {
							if (areas.length == 2) {
								const urlIdx = (isSamePref ? 0 : 1);
								const queryIdx = (isSamePref ? 1 : 0);
								if (!urls[urlIdx]) {
									urls[urlIdx] = (isStation) ? self.makeStationUrl(areas[0], areas[1]) : self.makeCityUrl(areas[0], areas[1]);
									// URLとは逆のindexへクエリを追加
									queries[queryIdx].push(params[idx]);
								} else {
									queries[0].push(params[idx]);
									queries[1].push(params[idx]);
								}
								allQueries.push(params[idx]);
								continue;
							}
						}
					}
					queries[0].push(params[idx]);
					queries[1].push(params[idx]);
					allQueries.push(params[idx]);
					if (pair[0] == conf.param.line) {
						lineParamValues.push(params[idx]);
					}
				}
				// 優先度の高いエリアURLを使用
				const idx = (urls[0] ? 0 : 1);
				url = urls[idx];
				query = self._makeResultQuery(queries[idx].join('&'));

				if (idx == 1 && url) {
					// 現ページと異なる都道府県の駅URLで、かつ路線パラメータが複数ある場合は都道府県URLとする
					// (複数路線で他県の駅のみを選択している場合にURLの都道府県を変えてしまうと、選択した路線の一部が遷移先で選べなくなってしまう可能性が有る為)
					if (lineParamValues.length > 1) {
						url = '';
						query = self._makeResultQuery(allQueries.join('&'));
					}
				}
			} else {
				// form送信先URLの書き換え無し
				query = self._makeResultQuery($form.serialize());
				if (excludeParams) {
					for (let idx = 0, max = excludeParams.length; idx < max; idx++) {
						query = Nifty.Utils.Url.removeParam(query, excludeParams[idx]);
					}
				}
			}
			return (url ? url : $form.attr('action')) + (query ? '?' : '') + query;
		}

		// public
		,create: function($form) {
			const searchForm = Object.create(this);
			searchForm._$form = $form;
			searchForm._conf = JSON.parse($form.find('[data-search-form-conf]').attr('data-search-form-conf'));
			$form.find('[data-easy-search-conf]:eq(0)').each(function() {
				searchForm._easySearchConf = JSON.parse($(this).attr('data-easy-search-conf'));
			});
			return searchForm;
		}

		// 判定/設定
		,isSearchStation: function() {
			return this._conf.form.isSearchStation;
		}
		,setSearchStation: function(isSearchStation) {
			return this._conf.form.isSearchStation = isSearchStation;
		}
		,getPrefId: function() {
			return this._conf.form.prefId;
		}
		,getAreasParamMap: function() {
			return this._conf.form.areasParamMap;
		}
		,hasCityParamValue: function(pref, city) {
			const params = this._conf.form.areasParamMap[this._conf.param.city];
			const value = this.makeCityValue(pref, city);
			return (params && params.indexOf(value) >= 0);
		}
		,hasLineParamValue: function(pref, line) {
			const params = this._conf.form.areasParamMap[this._conf.param.line];
			const value = this.makeLineValue(pref, line);
			return (params && params.indexOf(value) >= 0);
		}
		,hasStationParamValue: function(pref, station) {
			const params = this._conf.form.areasParamMap[this._conf.param.station];
			const value = this.makeStationValue(pref, station);
			return (params && params.indexOf(value) >= 0);
		}

		// URL生成
		,makeResultUrl: function() {
			return this._makeResultUrl((this._conf.form.isSearchStation) ? [ this._conf.param.city ] : [ this._conf.param.line, this._conf.param.station ]);
		}
		,makeResultQuery: function() {
			return this._makeResultQuery();
		}
		,makeResultConditionQuery: function(query) {
			// 条件のみのパラメータ生成
			// ※query指定有りの場合はqueryを基に、query指定無しの場合はフォームを基に生成
			// ※空文字列は指定有りと見なす(条件選択ポップアップの件数取得時など、条件によっては渡されるqueryが空文字列のケースが有る為)
			return Nifty.Utils.Url.removeParams(((query !== undefined && query !== null) ? query : this._makeResultQuery()), [ this._conf.param.city, this._conf.param.line, this._conf.param.station ]);
		}
		,makeResultMapAreaQuery: function() {
			// 地図検索用のエリアパラメータ生成
			const paramName = (this.isSearchStation()) ? this._conf.param.station : this._conf.param.city;
			let query = ''
			this._$form.find('input[name="' + paramName + '"]:checked:eq(0)').each(function () {
				query = paramName + '=' + $(this).val();
			});
			return query;
		}
		,makeExtendsCondParamLinkUrl: function(url) {
			// 条件引継ぎリンクURL
			const condQuery = this.makeResultConditionQuery();
			return Nifty.Utils.Url.addParam(url, condQuery);
		}
		,makeExtendsCondParamLinkMapUrl: function(url) {
			// 条件引継ぎリンクURL(地図検索)
			const areaQuery = this.makeResultMapAreaQuery();
			const condQuery = Nifty.Utils.Url.removeParams(this.makeResultConditionQuery(), [ this._conf.param.latitude, this._conf.param.longitude, this._conf.param.zoom ]);
			return Nifty.Utils.Url.addParam(Nifty.Utils.Url.addParam(url, areaQuery), condQuery);
		}
		,makeCityUrl: function(pref, city) {
			return this._conf.url.city.replace('${pref}', pref).replace('${city}', city);
		}
		,makeLineUrl: function(pref, line) {
			return this._conf.url.line.replace('${pref}', pref).replace('${line}', line);
		}
		,makeStationUrl: function(pref, station) {
			return this._conf.url.station.replace('${pref}', pref).replace('${station}', station);
		}
		,makeMapCityUrl: function(pref, city) {
			return this._conf.url.mapCity.replace('${pref}', pref).replace('${city}', city);
		}
		,makeMapStationUrl: function(pref, station) {
			return this._conf.url.mapStation.replace('${pref}', pref).replace('${station}', station);
		}
		,makeCityValue: function(pref, city) {
			return this._conf.value.city.replace('${pref}', pref).replace('${city}', city);
		}
		,makeLineValue: function(pref, line) {
			return this._conf.value.line.replace('${pref}', pref).replace('${line}', line);
		}
		,makeStationValue: function(pref, station) {
			return this._conf.value.station.replace('${pref}', pref).replace('${station}', station);
		}
		,getCheckedLineIds: function() {
			const lineIds = [];
			this._$form.find('input[name="' + this._conf.param.line + '"]:checked').each(function() {
				lineIds.push($(this).val());
			});
			return Nifty.Utils.Array.unique(lineIds);
		}
		,getCheckedStationIds: function() {
			const stationIds = [];
			this._$form.find('input[name="' + this._conf.param.station + '"]:checked').each(function() {
				stationIds.push($(this).val());
			});
			return Nifty.Utils.Array.unique(stationIds);
		}

		// 検索結果: 検索条件取得(画面表示用)
		,getSearchConditions: function() {
			const self = this;
			const conf = self._conf;
			const conditions = { area: [], cond: [] };
			self._$form.find('select option:selected,input:checked,input[type="text"]').each(function() {
				const tagName = $(this).get(0).tagName.toLowerCase();
				const tagType = $(this).attr('type');
				const name = $(this).attr('name');
				let text = '';
				if (tagName == 'option') {
					if ($(this).val()) {
						text = $(this).closest('select').attr('data-text');
					}
				} else if (tagName == 'input' && tagType == 'text') {
					if ($(this).val()) {
						text = $(this).attr('data-label') + "「" + $(this).val() + "」";
					}
				} else {
					text = $(this).attr('data-text');
				}

				if (name && text) {
					text = Nifty.Utils.Html.escape(text);
					if (name == conf.param.city) {
						if (!conf.form.isSearchStation) {
							conditions.area.push(text);
						}
					} else if (name == conf.param.station) {
						if (conf.form.isSearchStation) {
							conditions.area.push(text + '駅');
						}
					} else if (name != conf.param.sort && name != conf.param.num) {
						conditions.cond.push(text);
					}
				}
			});
			for (let key in conditions) {
				conditions[key] = Nifty.Utils.Array.unique(Nifty.Utils.Array.removeEmpty(conditions[key]));
			}
			return conditions;
		}

		// 検索結果: 指定inputのみchecked設定
		,checkThisInputOnly: function($checkbox) {
			this._$form.find('input[type="checkbox"][name="' + $checkbox.attr('name') + '"]:checked').prop('checked', false);
			this._$form.find('input[type="checkbox"][name="' + $checkbox.attr('name') + '"][value="' + $checkbox.val() + '"]').prop('checked', true);
		}
		// 検索結果: 指定nameのinput全てのchecked解除
		,uncheckInputAll: function(name) {
			this._$form.find('input[type="checkbox"][name="' + name + '"]:checked').prop('checked', false);
		}

		// 検索結果: 条件選択数チェック
		//   maxSelectNum: 選択可能上限数
		,_getCondSelectNumErrorMsg: function(title, paramName, maxSelectNum) {
			if (maxSelectNum > 0 && this._$form.find('input[type="checkbox"][name="' + paramName + '"]:checked').length > maxSelectNum) {
				return title + 'は' + maxSelectNum + (maxSelectNum < 10 ? 'つ' : '個') + 'までしか選択できません。';
			}
			return '';
		}
		,checkLineCondSelect: function($input) {
			if ($input.prop('checked')) {
				const errorMsg = this._getCondSelectNumErrorMsg('路線', this._conf.param.line, this._conf.maxSelectNum.line);
				if (errorMsg) {
					$input.prop('checked', false);
					alert(errorMsg);
				}
			}
		}
		,checkStationCondSelect: function($input) {
			if ($input.prop('checked')) {
				const errorMsg = this._getCondSelectNumErrorMsg('駅', this._conf.param.station, this._conf.maxSelectNum.station);
				if (errorMsg) {
					$input.prop('checked', false);
					alert(errorMsg);
				}
			}
		}

		// 検索結果: ajax取得
		,_prevResultUrl: location.pathname + '?' + location.search
		,isAjaxAllResultUrl: function(url) {
			// ajax更新範囲判定
			const checkParams = [ this._conf.param.city, this._conf.param.station ];
			return (Nifty.Utils.Url.filterParams(this._prevResultUrl, checkParams) != Nifty.Utils.Url.filterParams(url, checkParams));
		}
		,getResultAjax: function(url, isAjaxAll, option) {
			option.url = Nifty.Utils.Url.addParam(url, (isAjaxAll ? this._conf.query.resultAjaxAll : this._conf.query.resultAjax));
			Nifty.Utils.Ajax.ajax('searchResultAjax', option).done(function() {
				Nifty.WallPaint.Tracking.sendSearchEvent?.();
				Nifty.WallPaint.Tracking.sendViewListEvent?.();
			});
			this._prevResultUrl = url;

			Nifty.WallPaint.Tracking.sendPageView(option.url);
		}

		// 検索結果: 件数取得
		,_resultCounterMap: {}
		,_resultCounterMax: 100
		,_resultCounterAnimateDuration: 500
		,updateResultCounter: function($counter, url) {
			if ($counter.length <= 0) {
				return;
			}
			const self = this;
			const resultUrl = (url) ? url : self.makeResultUrl();
			const count = self._resultCounterMap[resultUrl];
			if (typeof count == 'undefined') {
				Nifty.Utils.Ajax.ajax('searchResultCount', {
					url: Nifty.Utils.Url.addParam(resultUrl, this._conf.query.resultCount)
					,dataType: 'json'
					,success: function(json) {
						if (json) {
							Nifty.Utils.Animation.animateCountUpOrDown($counter, json.count, self._resultCounterAnimateDuration);
							// 指定件数まで値を保持して再利用
							self._resultCounterMap[resultUrl] = json.count;
							// 指定件数を越えた場合は古いものを削除
							if (Object.keys(self._resultCounterMap).length > self._resultCounterMax) {
								for (let key in self._resultCounterMap) {
									delete self._resultCounterMap[key];
									break;
								}
							}
						}
					}
				});
			} else {
				Nifty.Utils.Animation.animateCountUpOrDown($counter, count, self._resultCounterAnimateDuration);
			}
		}


		// 地図結果: 件数取得
		,_resultMapCountRequestIdx: 0
		,getResultMapCount: function(map, option) {
			const self = this;
			if (map) {
				const currentRequestIdx = ++self._resultMapCountRequestIdx;
				setTimeout(function() {
					// 大量リクエスト回避の為、指定時間内に再リクエストが発生していない場合のみ実行
					if (currentRequestIdx == self._resultMapCountRequestIdx) {
						const url = self._$form.attr('action');
						const query = self.makeResultConditionQuery();
						Nifty.Utils.Execute.waitExecUntilCheckTrue(
							// 地図画面の初期表示で座標取得エラーとなるケースが有る為、座標取得可能となるまで実行を待機
							function() {
								const range = [ map.getBounds().getSouthWest().lat(), map.getBounds().getSouthWest().lng(), map.getBounds().getNorthEast().lat(), map.getBounds().getNorthEast().lng() ].join('-');

								option.url = Nifty.Utils.Url.addParam(url, self._conf.param.range + '=' + range + (query ? ('&' + query) : '') + '&' + self._conf.query.resultCount);
								Nifty.Utils.Ajax.ajax('searchResultMapCount', option);
							},
							function() {
								return (typeof map.getBounds() !== 'undefined');
							}
						);
					}
				}, 500);
			}
		}
		// 地図結果: 業者リスト取得
		,getResultMapList: function(latLng, option) {
			if (!option.url) {
				const url = this._$form.attr('action');
				const query = this.makeResultConditionQuery();

				option.url = Nifty.Utils.Url.addParam(url, this._conf.param.latLng + '=' + latLng + (query ? ('&' + query) : ''));
			}
			option.url = Nifty.Utils.Url.addParam(option.url, this._conf.query.resultAjax);
			Nifty.Utils.Ajax.ajax('getResultMapList', option);

			Nifty.WallPaint.Tracking.sendPageView(option.url);
		}

		,_hasAllKeys: function(data, keys) {
			if (keys) {
				for (let idx = 0, max = keys.length; idx < max; idx++) {
					if (!data[keys[idx]]) {
						return false;
					}
				}
			}
			return true;
		}
		// カンタン検索: 候補リスト取得(市区町村/駅)
		,getEasySearchResult: function(searchText, requireKeys, isMakeMapUrl) {
			const hits = { city: [], station: [] };
			const areasData = Nifty.Utils.Data.getAreasData();
			const prefDatas = areasData.prefData;
			const confDatas = areasData.confData;
			const stationDatas = areasData.stationData;
			const easySearchConf = this._easySearchConf;
			for (let pIdx = 0, pMax = areasData.prefIds.length; pIdx < pMax; pIdx++) {
				const prefId = areasData.prefIds[pIdx];
				if (easySearchConf.prefIds.length > 0 && easySearchConf.prefIds.indexOf(prefId) < 0) {
					continue;
				}
				const prefDataItem = Nifty.Utils.Data.createDataItem(prefDatas[prefId], confDatas.pref, prefId);

				// 市区町村
				if (!easySearchConf.type || easySearchConf.type == 'city') {
					for (let mcIdx = 0, mcMax = prefDataItem.mCityIds.length; mcIdx < mcMax; mcIdx++) {
						const mCityId = prefDataItem.mCityIds[mcIdx];
						const mCityData = prefDataItem.mCityData[mCityId];
						const cityIds = Nifty.Utils.Data.getDataValue(mCityData, confDatas.mCity, 'cityIds');
						for (let cIdx = 0, cMax = cityIds.length; cIdx < cMax; cIdx++) {
							const cityId = cityIds[cIdx];
							const cityData = prefDataItem.cityData[cityId];
							const cityName = Nifty.Utils.Data.getDataValue(cityData, confDatas.city, 'name');
							if (cityName.indexOf(searchText) >= 0) {
								const cityAlpha = Nifty.Utils.Data.getDataValue(cityData, confDatas.city, 'alpha');
								const cityDataItem = {
									url: (isMakeMapUrl) ? this.makeMapCityUrl(prefDataItem.alpha, cityAlpha) : this.makeCityUrl(prefDataItem.alpha, cityAlpha)
									,id: cityId
									,name: cityName
									,text: cityName + '（' + prefDataItem.name + '）'
									,latitude: Nifty.Utils.Data.getDataValue(cityData, confDatas.city, 'latitude')
									,longitude: Nifty.Utils.Data.getDataValue(cityData, confDatas.city, 'longitude')
								};
								if (this._hasAllKeys(cityDataItem, requireKeys)) {
									hits.city.push(cityDataItem);
								}
							}
						}
					}
				}
				// 駅
				if ((!easySearchConf.type || easySearchConf.type == 'station') && searchText != '駅') {
					const stationUrlMap = {};
					for (let sIdx = 0, sMax = prefDataItem.stationIds.length; sIdx < sMax; sIdx++) {
						const stationId = prefDataItem.stationIds[sIdx];
						const stationData = stationDatas[stationId];
						const stationName = Nifty.Utils.Data.getDataValue(stationData, confDatas.station, 'name') + '駅';
						if (stationName.indexOf(searchText) >= 0) {
							const stationAlpha = Nifty.Utils.Data.getDataValue(stationData, confDatas.station, 'alpha');
							const stationDataItem = {
								url: (isMakeMapUrl) ? this.makeMapStationUrl(prefDataItem.alpha, stationAlpha) : this.makeStationUrl(prefDataItem.alpha, stationAlpha)
								,id: stationId
								,name: stationName
								,text: stationName + '（' + prefDataItem.name + '）'
								,latitude: Nifty.Utils.Data.getDataValue(stationData, confDatas.station, 'latitude')
								,longitude: Nifty.Utils.Data.getDataValue(stationData, confDatas.station, 'longitude')
							};
							if (!stationUrlMap[stationDataItem.url] && this._hasAllKeys(stationDataItem, requireKeys)) {
								stationUrlMap[stationDataItem.url] = true;
								hits.station.push(stationDataItem);
							}
						}
					}
				}
			}
			return hits;
		}
		,getMapEasySearchResult: function(searchText) {
			return this.getEasySearchResult(searchText, [ 'latitude', 'longitude' ], true);
		}
		,addEasySearchSuggestData: function(data, header, items, type) {
			if (!items || items.length > 0) {
				data.push({
					header: header
					,items: items
					,type: type
				});
			}
		}
		,setEasySearchEvents: function($input, $submit, setEventFunction) {
			// エリアデータ取得完了までフォーム入力を無効化
			$input.attr('disabled', 'disabled');
			if ($submit) {
				$submit.addClass('is-disabled');
			}
			Nifty.Utils.Data.loadAreasData(function() {
				setEventFunction();

				// フォーム入力有効化
				$input.removeAttr('disabled');
				if ($submit) {
					$submit.removeClass('is-disabled');
				}
			});
		}
	};

	// 地図関連処理
	Nifty.WallPaint.Map = {
		// 地図上に表示するマーカー設定
		setMarkerIconLabel: function(marker, isActive, text) {
			if (marker) {
				if (!this._markerIconLabelConf) {
					this._markerIconLabelConf = {
						icon: {
							path: google.maps.SymbolPath.CIRCLE
							,fillColor: '#f8381f'
							,fillOpacity: 0.85
							,strokeColor: '#fff'
							,strokeWeight: 2
							,scale: 15
						}
						,label: {
							color: '#fff'
							,fontSize: '18px'
							,fontWeight: 'bold'
							,text: ''
						}
						,iconActive: {
							path: google.maps.SymbolPath.CIRCLE
							,fillColor: '#fff'
							,fillOpacity: 1.0
							,strokeColor: '#f8661f'
							,strokeWeight: 2
							,scale: 15
						}
						,labelActive: {
							color: '#f8661f'
							,fontSize: '18px'
							,fontWeight: 'bold'
							,text: ''
						}
					}
				}
				const count = parseInt(text);
				if (count == 1) {
					// 1件の場合はピンで表示
					marker.setIcon((isActive) ? '/wall-painting/assets/img/map-icon-shop-on.svg' : '/wall-painting/assets/img/map-icon-shop.svg');
					return;
				}

				const markerConf = this._markerIconLabelConf;
				const markerIcon = (isActive) ? markerConf.iconActive : markerConf.icon;
				const markerLabel = (isActive) ? markerConf.labelActive : markerConf.label;
				markerLabel.text = text;
				marker.setIcon(markerIcon);
				marker.setLabel(markerLabel);
			}
		}

		// 位置情報を取得可能か
		,isEnableGeo: function() {
			return !!(navigator.geolocation);
		}
		// 位置情報取得
		,getGeoCurrentPosition: function(success) {
			if (!this.isEnableGeo) {
				alert('この端末では位置情報を取得できません。');
				return;
			}
			navigator.geolocation.getCurrentPosition(
				function(position) {
					success(position);
				}
				,function(error) {
					alert('位置情報を取得できませんでした。');
				}
			);
		}
		// 現在地から探すリンク設定
		,setSearchMapGeoLink: function() {
			const self = this;
			$(document).on('click', 'a[data-search-map-geo-link]', function(e) {
				e.preventDefault();
				const urlBase = Nifty.Utils.Url.addParam($(this).attr('href'), $(this).attr('data-search-map-geo-link'));
				self.getGeoCurrentPosition(function(position) {
					location.href = urlBase.replace('${lat}', position.coords.latitude).replace('${lng}', position.coords.longitude);
				});
			});
		}
	};

	// 相場診断フォーム
	Nifty.WallPaint.SoubaShindan = {
		SEND_API_PATH: '/api/souba-shindan/form'

		,_$form: null
		,_$nestSelectParent: null
		,_$nestSelectList: null

		,init: function() {
			this._$form = $('#souoba-shindan-form');
			this._$nestSelectParent = this._$form.find('select[data-nest-select-parent="prefectures-cities"]');
			this._$nestSelectList = this._$form.find('[data-nest-select-list="prefectures-cities"]');
			if (this._$form.length <= 0 || this._$nestSelectParent.length <= 0 || this._$nestSelectList.length <= 0) {
				return;
			}

			this._setSubmitEvent();
			this._initFormData();
		}

		// 相場診断フォームLP用
		,initForLp: function() {
			this._$form = $('#souoba-shindan-form');
			if (this._$form.length <= 0) {
				return;
			}

			// ※LPはフォームのみのコンテンツの為、読み込み待ちが発生しないよう都道府県/市区町村などの入力用データをテンプレート側でHTMLに埋め込む
			//   (this._initFormData()の実行は不要)
			this._setSubmitEvent();
			this._dispatchDataInitializedEvent();
		}

		// 完了表示切り替え
		,_changeCompleteContent: function(target) {
			this._$form.find('[data-complete-content="' + target + '"]').show().siblings('[data-complete-content]').hide();
		}

		// フォーム送信イベント設定
		,_setSubmitEvent: function() {
			const self = this;
			this._$form.on('submit', function(e) {
				e.preventDefault();

				let isSuccess = false;
				Nifty.WallPaint.Function.setShowLoading(true);
				self._changeCompleteContent('sending');
				$.ajax({
					type: 'POST',
					url: self.SEND_API_PATH,
					data: self._$form.serialize(),
					dataType: 'json'
				}).done(function(data) {
					isSuccess = data.isSuccess;
				}).fail(function(xhr, status, e) {
				}).always(function() {
					const trackingCvPointData = self._$form.attr((isSuccess) ? 'data-tracking-souba-shindan-form-success' : 'data-tracking-souba-shindan-form-error');
					Nifty.WallPaint.Tracking.sendFormCvPoint?.(trackingCvPointData);
					setTimeout(function () {
						self._changeCompleteContent((isSuccess) ? 'success' : 'error');
						Nifty.WallPaint.Function.setShowLoading(false);
					}, 500);
				});
			});

			this._$form.on('click', '[data-step-form-submit][data-step-form-validate="true"]', function() {
				$(this).closest('form').submit();
			});
		}

		// nest-select.ts、step-form.ts側での初期化の為のイベント発火
		,_dispatchDataInitializedEvent: function() {
			document.dispatchEvent(new Event('souoba-shindan-form-data-initialized'));
		}

		// 都道府県、市区町村のセレクトボックス用データを生成
		,_initFormData: function() {
			const self = this;
			const nestSelectParentOptionHtmls = [];
			const nestSelectListData = {};
			Nifty.Utils.Data.loadAreasData(function() {
				const areasData = Nifty.Utils.Data.getAreasData();
				const wideareaDatas = areasData.areaData;
				const prefDatas = areasData.prefData;
				const confDatas = areasData.confData;
				for (const areaId of Object.keys(wideareaDatas)) {
					const areaData = wideareaDatas[areaId];
					const areaDataItem = Nifty.Utils.Data.createDataItem(areaData, confDatas.area, areaId);
					const wideareaName = areaDataItem.name;

					nestSelectParentOptionHtmls.push('<optgroup label="' + wideareaName + '">');
					for (const prefId of areaDataItem.prefIds) {
						const prefData = prefDatas[prefId];
						const prefDataItem = Nifty.Utils.Data.createDataItem(prefData, confDatas.pref, prefId);
						const prefName = Nifty.Utils.Data.getDataValue(prefData, confDatas.pref, 'name');

						const nestSelectCities = [];
						for (let mcIdx = 0, mcMax = prefDataItem.mCityIds.length; mcIdx < mcMax; mcIdx++) {
							const mCityId = prefDataItem.mCityIds[mcIdx];
							const mCityData = prefDataItem.mCityData[mCityId];
							const cityIds = Nifty.Utils.Data.getDataValue(mCityData, confDatas.mCity, 'cityIds');
							for (let cIdx = 0, cMax = cityIds.length; cIdx < cMax; cIdx++) {
								const cityId = cityIds[cIdx];
								const cityData = prefDataItem.cityData[cityId];
								const cityName = Nifty.Utils.Data.getDataValue(cityData, confDatas.city, 'name');
								nestSelectCities.push({
									text: cityName,
									value: cityName // 市区町村は送信する値に市区町村名を設定する
								});
							}
						}
						nestSelectParentOptionHtmls.push('<option value="' + prefId + '">' + prefName + '</option>');
						nestSelectListData[prefId] = nestSelectCities;
					}
					nestSelectParentOptionHtmls.push('</optgroup>');
				}

				self._$nestSelectParent.append(nestSelectParentOptionHtmls.join());
				self._$nestSelectList.html(JSON.stringify(nestSelectListData));

				self._$form.find('select[disabled]').removeAttr('disabled');
				self._dispatchDataInitializedEvent();
			});
		}
	};
});
